import React, { useState } from "react";

const CourseDetail = ({ data }) => {
  data.testimonials = [];
  const [activeTab, setActiveTab] = useState("overview");
  const [openAccordion, setOpenAccordion] = useState(null);
  const [openFaq, setOpenFaq] = useState(null);
  const [testimonialIndex, setTestimonialIndex] = useState(0);

  // data.testimonials = [];

  if (!data || !data.course) {
    return (
      <div className="container py-5 text-center">
        <p className="text-muted">Loading course details...</p>
      </div>
    );
  }

  return (
<div className="container-fluid px-0 course-page-bg">

  {/* ================= HERO ================= */}
  <section className="course-hero" style={{backgroundImage: `linear-gradient(rgba(6, 20, 60, 0.78), rgba(6, 20, 60, 0.78)),
        url("https://res.cloudinary.com/dg0eeyvud/image/upload/v1769941396/course1_r7hotx.avif")`,}}>
    <div className="container py-5">
      <div className="row align-items-center">
        {/* LEFT */}
        <div className="col-lg-8 mb-4 mb-lg-0 text-white">
          <h1 className="fw-bold display-6 mb-3 title">
            {data.course.title}
          </h1>

          <p className="fs-5 text-white-50">
            {data.course.description}
          </p>

          <div className="d-flex flex-wrap gap-3 mt-4">
            {data.actions?.applyNow && (
              <a
                href={data.actions.applyNow}
                className="btn btn-warning btn-lg hero-btn pulse"
                target="_blank"
                rel="noreferrer"
              >
                Apply Now
              </a>
            )}

            <a
              href={data.actions?.campusTour}
              className="btn btn-outline-light btn-lg hero-btn"
              target="_blank"
              rel="noreferrer"
            >
              Campus Tour
            </a>
          </div>
        </div>

        {/* RIGHT SNAPSHOT */}
        <div className="col-lg-4">
          <div className="snapshot-card">
            <InfoRow label="Duration" value={data.course.duration} />
            <InfoRow label="Study Mode" value={data.course.delivery} />
            <InfoRow
              label="Locations"
              value={data.course.locations?.join(", ")}
            />
            <InfoRow
              label="Intakes"
              value={data.course.intakes?.join(", ")}
            />

            <a
              href={data.actions?.applyNow}
              className="btn btn-primary w-100 mt-3 snapshot-btn"
            >
              Apply Now
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  {/* ================= COURSE STATS ================= */}
  <section className="course-stats-wrapper">
    <div className="container">
      <div className="course-stats">
        <div className="stat-item">
          <strong>{data.course.duration}</strong>
          <span>Duration</span>
        </div>

        <div className="stat-item">
          <strong>{data.course.delivery}</strong>
          <span>Study Mode</span>
        </div>

        <div className="stat-item">
          <strong>{data.course.locations?.length}</strong>
          <span>Campuses</span>
        </div>

        <div className="stat-item">
          <strong>{data.course.awardedDegree}</strong>
          <span>Award</span>
        </div>
      </div>
    </div>
  </section>

  {/* ================= TABS ================= */}
  <section className="container pb-5 course-tabs-section">
    <div className="tabs-wrapper">
      <ul className="nav nav-pills gap-2 flex-nowrap overflow-auto">
        <Tab id="overview" label="Overview" activeTab={activeTab} setActiveTab={setActiveTab} />
        <Tab id="curriculum" label="Curriculum" activeTab={activeTab} setActiveTab={setActiveTab} />
        <Tab id="assessment" label="Assessment" activeTab={activeTab} setActiveTab={setActiveTab} />
        <Tab id="entry" label="Entry Requirements" activeTab={activeTab} setActiveTab={setActiveTab} />
        <Tab id="careers" label="Careers" activeTab={activeTab} setActiveTab={setActiveTab} />
        <Tab id="fees" label="Fees" activeTab={activeTab} setActiveTab={setActiveTab} />
      </ul>
    </div>

    <div className="tab-content-card">
      {activeTab === "overview" && (
        <div className="simple-content">
          {Object.values(data.overview || {}).map((item, i) => (
            <p key={i}>{item}</p>
          ))}
        </div>
      )}

      {activeTab === "curriculum" && (
        <div className="simple-content">
          {Object.entries(data.curriculum || {}).map(([year, subjects]) => (
            <div key={year} className="content-block">
              <h6 className="block-title">{year}</h6>
              <ul>
                {subjects.map(subject => (
                  <li key={subject}>{subject}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}

      {activeTab === "assessment" && (
        <div className="simple-content">
          <div className="content-block">
            <h6 className="block-title">assessment</h6>
            <ul>
              {data.assessment?.map(item => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {activeTab === "entry" && (
        <div className="simple-content">
          <p className="fw-semibold">
            {data.entryRequirements?.standard}
          </p>
          <ul>
            {data.entryRequirements?.process?.map(step => (
              <li key={step}>{step}</li>
            ))}
          </ul>
        </div>
      )}

      {activeTab === "careers" && (
        <div className="simple-content">
          <ul>
            {data.careers?.map(career => (
              <li key={career}>{career}</li>
            ))}
          </ul>
        </div>
      )}

      {activeTab === "fees" && (
        <div className="simple-content">
          {Object.entries(data.course.fees || {}).map(([key, value]) => (
            <p key={key}>
              <strong>{key.replace(/([A-Z])/g, " $1")}:</strong> {value}
            </p>
          ))}
        </div>
      )}
    </div>
  </section>

  {/* ================= TESTIMONIALS ================= */}
  {data.testimonials?.length > 0 && (
    <section className="testimonial-modern-section">
      <div className="container text-center">
        <h2 className="fw-bold mb-5">Voices of Our Students</h2>

        <div className="testimonial-wrapper">
          <button
            className="testimonial-nav left"
            onClick={() =>
              setTestimonialIndex(prev =>
                prev === 0 ? data.testimonials.length - 1 : prev - 1
              )
            }
          >
            ‹
          </button>

          <div className="testimonial-card-modern">
            <div className="quote-icon">“</div>

            <p className="testimonial-text">
              {data.testimonials[testimonialIndex].feedback}
            </p>

            <div className="testimonial-user">
              <div className="avatar">
                {data.testimonials[testimonialIndex].name.charAt(0)}
              </div>
              <strong>
                {data.testimonials[testimonialIndex].name}
              </strong>
            </div>
          </div>

          <button
            className="testimonial-nav right"
            onClick={() =>
              setTestimonialIndex(prev =>
                prev === data.testimonials.length - 1 ? 0 : prev + 1
              )
            }
          >
            ›
          </button>
        </div>

        <div className="testimonial-dots">
          {data.testimonials.map((_, i) => (
            <span
              key={i}
              className={`dot ${testimonialIndex === i ? "active" : ""}`}
              onClick={() => setTestimonialIndex(i)}
            />
          ))}
        </div>
      </div>
    </section>
  )}

  {/* ================= FAQ ================= */}
  {data.faq && (
    <section className="container py-4 faq-modern-section">
      <h2 className="fw-bold mb-3 text-center">
        Frequently Asked Questions
      </h2>

      <div className="faq-modern-wrapper">
        {data.faq.map(item => (
          <div
            key={item.id}
            className={`faq-modern-item ${openFaq === item.id ? "open" : ""}`}
          >
            <button
              className="faq-modern-question"
              onClick={() =>
                setOpenFaq(openFaq === item.id ? null : item.id)
              }
            >
              <span>{item.question}</span>
              <span className="icon">
                {openFaq === item.id ? "−" : "+"}
              </span>
            </button>

            {openFaq === item.id && (
              <div className="faq-modern-answer">
                {Array.isArray(item.answer) ? (
                  <ul>
                    {item.answer.map(ans => (
                      <li key={ans}>{ans}</li>
                    ))}
                  </ul>
                ) : (
                  <p>{item.answer}</p>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  )}
</div>

  );
};

/* ================= SUB COMPONENTS ================= */

const InfoRow = ({ label, value }) => (
  <div className="mb-2">
    <small className="text-muted">{label}</small>
    <div className="fw-semibold">{value}</div>
  </div>  
);

// const Highlight = ({ label, value }) => (
//   <div className="col-md-3 mb-3">
//     <div className="border rounded p-3 h-100">
//       <small className="text-muted">{label}</small>
//       <h6 className="fw-bold mb-0">{value}</h6>
//     </div>
//   </div>
// );

const Tab = ({ id, label, activeTab, setActiveTab }) => (
  <button className={`btn ${activeTab === id ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setActiveTab(id)}>
    {label}
  </button>
);

// const Accordion = ({ title, open, onClick, children }) => (
//   <div className="card mb-3">
//     <div
//       className="card-header fw-bold d-flex justify-content-between align-items-center"
//       style={{ cursor: "pointer" }}
//       onClick={onClick}
//     >
//       {title}
//       <span>{open ? "−" : "+"}</span>
//     </div>
//     {open && <div className="card-body">{children}</div>}
//   </div>
// );

export default CourseDetail;
